<form (ngSubmit)="submitPayment(paymentForm)" #paymentForm="ngForm">
  <label for="invoice">Номер на фактура</label>
  <input type="number" id="invoice" name="invoice" ngModel required>

  <label for="amount">Сума</label>
  <input type="number" id="amount" name="amount" ngModel required>

  <label for="exp_time">Крайна дата/час за плащане</label>
  <input type="text" id="exp_time" name="exp_time" ngModel required>

  <button type="submit">Плати</button>
</form>
<hr/>
<div >
  <p>Получен код за плащане: {{ response }}</p>
  <p>Получена Грешка: {{ error }}</p>
</div>
